import {
  faPlus,
  faMinus,
  faTimes,
  faDivide,
} from '@fortawesome/pro-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const operationIcons = {
  add: faPlus,
  subtract: faMinus,
  multiply: faTimes,
  divide: faDivide,
}

export const OperationIcon = ({ type }) => (
  <FontAwesomeIcon icon={operationIcons[type]} />
)
